import React from 'react';
import { useSearchContext } from 'context/SearchContext';

type Props = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
};

const ViewToggle: React.FC<Props> = ({ className, size = 'small' }) => {
  const { viewMode, setViewMode } = useSearchContext();

  const value: 'list' | 'map' = viewMode === 'map' ? 'map' : 'list';

  const sizeClasses = {
    small: 'px-3 py-1 text-xs',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base',
  };

  const buttonClass = sizeClasses[size];

  return (
    <div
      className={`${className} inline-flex rounded-md overflow-hidden border border-card-border`}
      role="group"
      aria-label="view mode"
      data-testid="view-toggle"
    >
      <button
        onClick={() => setViewMode('list')}
        className={`${buttonClass} font-medium transition-opacity ${
          value === 'list'
            ? 'bg-primary text-white'
            : 'bg-card-bg text-text-secondary hover:opacity-80'
        }`}
        aria-label="list view"
        data-testid="view-toggle-list"
      >
        LIST
      </button>
      <button
        onClick={() => setViewMode('map')}
        className={`${buttonClass} font-medium transition-opacity border-l border-card-border ${
          value === 'map'
            ? 'bg-primary text-white'
            : 'bg-card-bg text-text-secondary hover:opacity-80'
        }`}
        aria-label="map view"
        data-testid="view-toggle-map"
      >
        MAP
      </button>
    </div>
  );
};

export default ViewToggle;

